import { connectedAccountsStore } from '../../store/store';
import { mutatorAction } from 'satcheljs';
export var updateEditIncomingSecurity = mutatorAction('updateEditIncomingSecurity', function (incomingSecurity) {
    var store = connectedAccountsStore();
    store.editAccountState.incomingSecurity = incomingSecurity;
});
//# sourceMappingURL=updateEditIncomingSecurity.js.map